"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const _1 = require(".");
function default_1({ setPaymentDetail, setPaymentDetailDelivery, }) {
    return __awaiter(this, void 0, void 0, function* () {
        yield (0, _1.getPaymentDetailData)().then(detailData => {
            setPaymentDetail(detailData);
            if (setPaymentDetailDelivery) {
                // ! 구매자 권리 포기(배송 받았어요) 했을 때, 서버에서 삭제된 배송지와 개인통관고유부호 그대로 적용
                const { order_delivery: default_delivery } = detailData;
                setPaymentDetailDelivery(prev => (Object.assign(Object.assign({}, prev), { default_delivery, second_customvalue: i18next_1.default.t('없음') })));
            }
        });
    });
}
exports.default = default_1;
